import React from "react";
import { useNavigate } from "react-router-dom";
import { localImages } from "../../common/localImages";

const UnderConstruction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center bg-white justify-center  text-center p-6">
      <div className=" p-8  max-w-md w-full">
        <div className="">
          <img src={localImages.construction} alt="construction" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800">
          Page Under Construction
        </h1>
        <p className="text-gray-600 mt-2">
          We're working hard to bring this page to you soon. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;
